import { render, staticRenderFns } from "./tenant.vue?vue&type=template&id=5b1e904b"
import script from "./tenant.vue?vue&type=script&lang=js"
export * from "./tenant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports